module.exports = __webpack_public_path__ + "img/ChanChaoLogo.787eb0a9.png";